
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/conversation-list-root",
      function () {
        return require("private-next-pages/x/api/chat/conversation-list-root.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/conversation-list-root"])
      });
    }
  